import Swipeable from './behaviours/swipeable';
import React from 'react';
import PropTypes from 'prop-types';
import {normaliseImagePath} from "../utilities";


export default class Gallery extends React.Component {
    static defaultProps = {
        id:'0',
        buttonInline: false
    }
    constructor (props){
        super(props);

        this.events = {
            open: 'gallery.open.'+props.id,
        }

        this.state = {
            index: 0,
            modal_open: false
        };

        this.EventManager = window.app.eventManager;
        this.EventManager.createEvent(this.events.open, 'Gallery open modal for '+props.id, 'This event is triggered when you want to open the relevant youtube modal', this);
    }

    componentDidMount() {
        this.EventManager.subscribe(this.events.open, (e) => {
            this.toggleModal(true);
        });
    }

    decreaseIndex = () =>{
        let currentIndex = this.state.index;
        this.setState({index: (currentIndex - 1 ) < 0 ? 0 : currentIndex - 1});
    }

    increaseIndex = () => {
        let currentIndex = this.state.index;
        this.setState({index: (this.props.images.length <= (currentIndex + 1)) ? currentIndex : currentIndex + 1});
    }

    toggleModal = (open = null) =>{
        open = (open !== null) ? open : !this.state.open;
        this.setState({modal_open: open});
    }

    closeModal = () =>{
        const closeEvent = new Event('galleryClose');
        this.setState({modal_open: false}, () => {
            document.dispatchEvent(closeEvent);
        });
    }

    renderItem = (media) => {
        if(media.type === 'youtube') {
            return(
                <div className="gallery--video-wrapper" style={this.getGalleryItemStyles()}>
                    <iframe frameBorder="0" allowFullScreen className="yt-plater" id="player" type="text/html"  width="560" height="349" src={this.getYoutubeVideoUrl(media.url)} />
                </div>
            );
        } else if(media.type === 'vimeo'){
            return (
                <div className="gallery--video-wrapper" style={this.getGalleryItemStyles()}>
                    <iframe frameBorder="0" allowFullScreen className="yt-plater" id="player" width="560" height="349" src={this.getVimeoVideoUrl(media.url)} />
                </div>
            )
        } else {
            let path = media.path ? normaliseImagePath(media.path) : normaliseImagePath(media);
            return <img src={path} alt={media.alt} />
        }
    }

    getYoutubeVideoUrl(url){
        let videoId = this.getYouTubeGetID(url);
        return "//www.youtube-nocookie.com/embed/" + videoId + "?autoplay=1&rel=0"
    }

    getYouTubeGetID(url){
        var ID = '';
        url = url.replace(/(>|<)/gi,'').split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
        if(url[2] !== undefined) {
            ID = url[2].split(/[^0-9a-z_\-]/i);
            ID = ID[0];
        }
        else {
            ID = url;
        }
        return ID;
    }

    getVimeoVideoUrl(url){
        const pieces = url.split('/');
        const id = pieces[pieces.length - 1];
        return 'https://player.vimeo.com/video/' + id + '?dnt=1';
    }

    getGalleryItemStyles() {
        let styles = {};

        if (this.props.forcedWidth) styles.width = `${this.props.forcedWidth}px`;
        if (this.props.forcedHeight) styles.height = `${this.props.forcedHeight}px`;
        if (this.props.forcedHeight && this.props.forcedWidth) styles.paddingBottom = '0px';

        return styles;
    }

    render () {
        const handlers = {onSwipedLeft: this.increaseIndex, onSwipedRight: this.decreaseIndex};

        return (
            <React.Fragment>
                {this.props.buttonInline && !this.state.modal_open && <div key="gallery-button" className={this.props.buttonClass} onClick={this.toggleModal}>{this.props.buttonText}</div>}
                <div className={"gallery " + (this.state.modal_open ? ' open ' : ' ') + this.props.class } style={this.props.style}>
                    {
                        !this.props.buttonInline && !this.state.modal_open && <div key="gallery-button" className={this.props.buttonClass} onClick={this.toggleModal}>{this.props.buttonText}</div>
                    }
                    { this.state.modal_open &&  [
                        <Swipeable className="gallery--items" {...handlers} style={this.getGalleryItemStyles()}>
                            <div className="gallery--close" onClick={this.closeModal}>×</div>
                            { this.renderItem(this.props.images[this.state.index]) }
                            <div className="gallery--info">
                                { this.props.images.length > 1 && 'Showing ' +  (this.state.index + 1) + ' of ' + this.props.images.length + ' - ' }
                                { this.props.images[this.state.index].alt ? (this.props.images[this.state.index].alt) : '' }
                            </div>
                            <div className="gallery--controls">
                                { <div className="gallery--prev-container">
                                    <button className={this.state.index === 0 ? 'disabled gallery--prev-control' : 'gallery--prev-control'} onClick={this.decreaseIndex}><i
                                        className="icn icn-angle-left"></i>
                                    </button>
                                </div>}
                                {<div className="gallery--next-container">
                                    <button className={this.state.index === (this.props.images.length - 1) ? 'disabled gallery--next-control' : 'gallery--next-control'} onClick={this.increaseIndex}><i
                                        className="icn icn-angle-right"></i>
                                    </button>
                                </div>}
                            </div>
                        </Swipeable>,
                        <div className="gallery--shroud" onClick={this.closeModal } />
                    ]}
                </div>
            </React.Fragment>
        );

    }
}